exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-08d382d8] {\n  border: 1px solid #d7d8da;\n}\n.table th[data-v-08d382d8], .table td[data-v-08d382d8] {\n  font-size: 12px;\n}", ""]);

// exports
